import React from 'react';
type IconProps = {
  className?: string;
};
export function OneClickIcon({
  className
}: IconProps) {
  return <svg viewBox="0 0 24 24" className={className} aria-hidden="true" data-id="element-262" data-mp="u1i41i0i032c">
      <path d="M4 20 L14.5 9.5" stroke="currentColor" strokeWidth="3.2" strokeLinecap="round" data-id="element-263" data-mp="yztcppf247iz" />
      <path d="M17 3v3M15.5 4.5h3M20.5 8.5v3M19 10h3M11 2.5v2.4M9.8 3.7h2.4" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" data-id="element-264" data-mp="13q005lxu1lzn" />
    </svg>;
}
export function SizeIcon({
  className
}: IconProps) {
  return <svg viewBox="0 0 24 24" className={className} aria-hidden="true" data-id="element-265" data-mp="1cq58pzeriqfe">
      <rect x="3" y="4" width="18" height="16" fill="none" stroke="currentColor" strokeWidth="1.8" strokeDasharray="2.2 2" data-id="element-266" data-mp="1hq1bjvbq4btd" />
      <rect x="3" y="12.5" width="9" height="7.5" fill="currentColor" data-id="element-267" data-mp="1mpdysh6ibkwh" />
    </svg>;
}
export function ProtectIcon({
  className
}: IconProps) {
  return <svg viewBox="0 0 24 24" className={className} aria-hidden="true" data-id="element-268" data-mp="3jjh633axmatm">
      <path d="M12 2.5 L20 5.5 V11.5 C20 16.5 16.6 20 12 21.5 C7.4 20 4 16.5 4 11.5 V5.5 Z" fill="currentColor" data-id="element-269" data-mp="3ohabvv8bp2td" />
      <path d="M12 5 L17.8 7.1 V11.5 C17.8 15.2 15.4 18 12 19.2 Z" fill="white" opacity="0.55" data-id="element-270" data-mp="19ahjidc8600i" />
    </svg>;
}
export function OrientIcon({
  className
}: IconProps) {
  return <svg viewBox="0 0 24 24" className={className} aria-hidden="true" data-id="element-271" data-mp="zk4zqnc8iavf">
      <path d="M9 7.5 L14.5 13 L9 18.5 L3.5 13 Z" fill="currentColor" data-id="element-272" data-mp="uksc40djgzrs" />
      <path d="M12.5 4.2 A8 8 0 1 1 11 20.8" fill="none" stroke="currentColor" strokeWidth="2" data-id="element-273" data-mp="uifph9wu618e" />
      <path d="M12.2 1.6 L15.6 4.4 L12 6.8 Z" fill="currentColor" data-id="element-274" data-mp="1s5oehew1psf5" />
    </svg>;
}
export function SupportIcon({
  className
}: IconProps) {
  return <svg viewBox="0 0 24 24" className={className} aria-hidden="true" data-id="element-275" data-mp="1i8teerk4jjyr">
      <path d="M4.5 9.5 L12 3.5 L19.5 11 L18.5 13 L5 13 Z" fill="currentColor" data-id="element-276" data-mp="1e8ss6kqsa4h5" />
      <path d="M3.5 20.5h17M6.5 13v7.5M17 13v7.5" stroke="currentColor" strokeWidth="1.8" data-id="element-277" data-mp="6upnxvcqwdyg" />
      <path d="M9.5 20.5v-3.2a2.2 2.2 0 0 1 4.4 0v3.2" fill="none" stroke="currentColor" strokeWidth="1.8" data-id="element-278" data-mp="6sczr0ge97cy" />
    </svg>;
}
export function LayoutIcon({
  className
}: IconProps) {
  return <svg viewBox="0 0 24 24" className={className} aria-hidden="true" data-id="element-279" data-mp="486saiskmyrn">
      <rect x="3" y="3" width="8.2" height="10" fill="currentColor" data-id="element-280" data-mp="98ujb4gsvflv" />
      <rect x="12.8" y="3" width="8.2" height="6.5" fill="currentColor" data-id="element-281" data-mp="3qi9el2naq8cc" />
      <rect x="3" y="14.6" width="8.2" height="6.4" fill="currentColor" data-id="element-282" data-mp="3vgko1c9oigu1" />
      <rect x="12.8" y="11.1" width="8.2" height="9.9" fill="currentColor" data-id="element-283" data-mp="3vinokq8gjsd0" />
    </svg>;
}
export function HollowIcon({
  className
}: IconProps) {
  return <svg viewBox="0 0 24 24" className={className} aria-hidden="true" data-id="element-284" data-mp="3mgxybnqbazgt">
      <path d="M3.5 7v10.5c0 2 3.8 3.5 8.5 3.5s8.5-1.5 8.5-3.5V7Z" fill="currentColor" data-id="element-285" data-mp="37r8h6j1tqkuw" />
      <ellipse cx="12" cy="7" rx="8.5" ry="3.5" fill="currentColor" data-id="element-286" data-mp="3cq2z7iryw5dy" />
      <ellipse cx="12" cy="7" rx="6" ry="2.1" fill="none" stroke="white" strokeWidth="1.2" data-id="element-287" data-mp="3cqcot593oaj4" />
    </svg>;
}
export function TextureIcon({
  className
}: IconProps) {
  return <svg viewBox="0 0 24 24" className={className} aria-hidden="true" fill="none" stroke="currentColor" strokeWidth="1.5" data-id="element-288" data-mp="32qlup4ogbxjk">
      <rect x="3.5" y="3.5" width="17" height="17" data-id="element-289" data-mp="2k3v4tptx0dd7" />
      <path d="M7.5 3.5v17M12 3.5v17M16.5 3.5v17M3.5 7.5h17M3.5 12h17M3.5 16.5h17" data-id="element-290" data-mp="2f51ug69xd2h9" />
    </svg>;
}
export function LabelIcon({
  className
}: IconProps) {
  return <svg viewBox="0 0 24 24" className={className} aria-hidden="true" data-id="element-291" data-mp="2t1x3hyq6etxb">
      <text x="12" y="17.5" textAnchor="middle" fontSize="14" fontWeight="800" fontFamily="Figtree, sans-serif" fill="currentColor" data-id="element-292" data-mp="2o3n8pp8d5vc8">
        Aa
      </text>
    </svg>;
}
export function HoleIcon({
  className
}: IconProps) {
  return <svg viewBox="0 0 24 24" className={className} aria-hidden="true" data-id="element-293" data-mp="3burhapc2cfzy">
      <path d="M12 2.5 L21 6.5 V17 L12 21.5 L3 17 V6.5 Z" fill="currentColor" data-id="element-294" data-mp="3btzplpll72ey" />
      <path d="M3 6.5 L12 10.5 L21 6.5 M12 10.5 V21.5" stroke="white" strokeWidth="0.9" fill="none" opacity="0.7" data-id="element-295" data-mp="37uh4ottrmrc4" />
      <ellipse cx="7.6" cy="14.6" rx="1.9" ry="2.6" fill="white" transform="rotate(-18 7.6 14.6)" data-id="element-296" data-mp="3lt8c5xe4hera" />
    </svg>;
}
export function FormlabsLogo({
  className
}: IconProps) {
  return <svg viewBox="0 0 32 24" className={className} aria-hidden="true" fill="none" stroke="currentColor" strokeWidth="2" strokeLinejoin="round" data-id="element-297" data-mp="4q2ttdnnjllm">
      <path d="M2 4 L16 13 L30 4 L24 20 L16 13 L8 20 Z" data-id="element-298" data-mp="diw9hc70gn00" />
      <path d="M16 13 L13 21 M16 13 L19 21" data-id="element-299" data-mp="djftqzk4vnh7" />
    </svg>;
}
export function PreFormIcon({
  className
}: IconProps) {
  return <svg viewBox="0 0 24 24" className={className} aria-hidden="true" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round" data-id="element-300" data-mp="ijtqvmk75d0g">
      <path d="M12 2.5 L20.5 6.5 V17 L12 21.5 L3.5 17 V6.5 Z" data-id="element-301" data-mp="3lzr5c7pe574l" />
      <path d="M3.5 6.5 L12 10.8 L20.5 6.5 M12 10.8 V21.5 M8 4.5 V19.5 M16 4.5 V19.5" data-id="element-302" data-mp="3qxso0riwn4fj" />
    </svg>;
}
export function TouchpointIcon({
  className
}: IconProps) {
  return <svg viewBox="0 0 24 24" className={className} aria-hidden="true" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" data-id="element-303" data-mp="3vusswz40q152">
      <path d="M8 3.5 L11.5 7 V20.5 M7 20.5 H17" data-id="element-304" data-mp="1b651lq1iouaz" />
    </svg>;
}
export function MinimaIcon({
  className
}: IconProps) {
  return <svg viewBox="0 0 24 24" className={className} aria-hidden="true" data-id="element-305" data-mp="2vne1iqvuerjv">
      <path d="M4 17 L18 6 L20.5 9 L7 19.5 Z" fill="currentColor" data-id="element-306" data-mp="2qpcexvz7ka3n" />
      <path d="M4 17 L3 21 L7 19.5" fill="currentColor" data-id="element-307" data-mp="2lyw2ae37osic" />
    </svg>;
}
export function OverhangsIcon({
  className
}: IconProps) {
  return <svg viewBox="0 0 24 24" className={className} aria-hidden="true" fill="currentColor" data-id="element-308" data-mp="2gyrlso2azxs4">
      <rect x="2.5" y="3" width="19" height="3.2" data-id="element-309" data-mp="2cyhdh4r1gva3" />
      <rect x="4" y="6" width="1.8" height="15" data-id="element-310" data-mp="2cvuw6decj1eo" />
      <rect x="8.3" y="6" width="1.8" height="15" data-id="element-311" data-mp="27y35tntcnncl" />
      <rect x="12.6" y="6" width="1.8" height="15" data-id="element-312" data-mp="281h7etu6vsiz" />
      <rect x="16.9" y="6" width="1.8" height="15" data-id="element-313" data-mp="231323jjz2won" />
    </svg>;
}
export function StabilizationIcon({
  className
}: IconProps) {
  return <svg viewBox="0 0 24 24" className={className} aria-hidden="true" fill="currentColor" data-id="element-314" data-mp="1y3b88jzrp0ht">
      <path d="M5 14 L18 4 L20.5 7 L7.5 17 Z" data-id="element-315" data-mp="16kh24rcsx90" />
      <rect x="4" y="15" width="2" height="6.5" data-id="element-316" data-mp="3sepyd1wox1y3" />
      <rect x="8.5" y="13" width="2" height="8.5" data-id="element-317" data-mp="3scvc9k9on3sf" />
    </svg>;
}
export function ReinforcementsIcon({
  className
}: IconProps) {
  return <svg viewBox="0 0 24 24" className={className} aria-hidden="true" fill="currentColor" data-id="element-318" data-mp="1vh0s7733p4pw">
      <path d="M4 12 L18 4 L20 7 L6 15 Z" data-id="element-319" data-mp="1grw4xbhg8aax" />
      <rect x="4" y="13" width="1.8" height="8.5" data-id="element-320" data-mp="1gt7b1hyd9u57" />
      <rect x="8" y="11" width="1.8" height="10.5" data-id="element-321" data-mp="1lqft7ijily6g" />
      <rect x="12" y="9" width="1.8" height="12.5" data-id="element-322" data-mp="1lqz269r6tc8c" />
      <rect x="16" y="7" width="1.8" height="14.5" data-id="element-323" data-mp="29fs3klqkwcac" />
    </svg>;
}